import { useAuth, useOrganization } from '@clerk/clerk-react'
import { useQuery } from '@tanstack/react-query'

import { QUERY_GC_TIME_MS, QUERY_STALE_TIME_MS } from '@/config/constants'
import { credentialKeys } from '@/lib/queryKeys'
import { fetchEcwCredentialStatus } from './api'

export function useEcwCredentialStatusQuery(enabled = true) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useQuery({
    queryKey: credentialKeys.status(organization?.id, 'ecw'),
    queryFn: async ({ signal }) => {
      const token = await getToken()
      if (!token) throw new Error('No authentication token available')
      return fetchEcwCredentialStatus(token, signal)
    },
    enabled: enabled && !!organization?.id,
    staleTime: QUERY_STALE_TIME_MS,
    gcTime: QUERY_GC_TIME_MS,
    retry: false,
    refetchOnWindowFocus: 'always',
  })
}
